import React, {Component} from 'react'
import PropTypes from 'prop-types'

import List from './list'
import Label from '../label'

import './list-checked.styl'
class ListCustom extends Component {

    static propTypes = {
        label: PropTypes.string,
        className: PropTypes.string,
        printable: PropTypes.bool,
        disabled: PropTypes.bool,
        collection:  PropTypes.arrayOf(PropTypes.object).isRequired,
        view: PropTypes.func.isRequired,
        onSelect: PropTypes.func
    }

    select(value){
        const {collection} = this.props;
        const inside = collection.find( e => e.id === value.id)
        !inside && collection.push(value);
        this.setState({collection})
        this.props.onSelect({collection})
    }

    render() {
        const { printable=true } = this.props
        if(!printable){
            return <div className="hide"></div>
        }
        const {label, view, disabled=false, className=false} = this.props
        const {collection} = this.props;
        const list = collection.map(e => React.createElement(view, e))

        return <div className={'form list-checked' +  (className ? ' ' + className : '')}>
            <Label>{label}</Label>
            <div className={'list-checked-content' + (disabled ? ' disabled' : '')}>
                <List collection={list} />
            </div>
        </div>
    }
}

export default ListCustom
